<app-header (locale)="onLocaleChange($event)"></app-header>
<div
  class="app-body"
  [ngClass]="{
    'pt-0 app-body-form': (status$ | async) !== 'FAILED',
    'mt-2 pt-5': (status$ | async) === 'FAILED',
  }"
>
  <main
    class="main d-flex align-items-center"
    [ngClass]="{ 'mt-n5': (status$ | async) === 'FAILED' }"
  >
    <div class="container pt-1">
      <div class="alert-wrapper justify-content-center">
        <div class="container text-center">
          <div
            role="alert"
            class="alert w-100 alert-danger"
            *ngIf="(status$ | async) === 'FAILED'"
          >
            <strong>{{ 'admin.alerts.headerError' | translate }}</strong>
            {{ error$ | async }}
          </div>
        </div>
      </div>
      <ng-container *ngIf="(status$ | async) !== 'REGISTERED'">
        <div
          class="card-group mb-3"
          [ngClass]="{ 'mt-0': (status$ | async) === 'FAILED' }"
        >
          <div class="card">
            <div class="card-body card_width shadow shadow-no-mobile mx-auto">
              <div class="row w-100">
                <div class="col-12 px-4 px-md-5 py-3 py-md-4">
                  <app-registration-login-details-form
                    [languageId]="languageId"
                    [newLoginDetails]="newLoginDetails"
                    (submitEvent)="registerAction($event)"
                    [registerOption]="'partner'"
                  >
                  </app-registration-login-details-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </main>
</div>
